import React from 'react'

import { Spacings } from 'common/builder/components/chart/FlowChart/nodes/shared/styles'
import { toPx } from 'common/builder/components/chart/utils/toPx'

const Style: React.CSSProperties = {
  height: toPx(Spacings.BLOCK_VERTICAL_SPACING * 2),
}

export const EmptyNextStepSpacer = () => {
  return <view style={Style} />
}
